export const bankReconciliationDynamicMessagesEn = {
  bankreconciliation_banktransactionid_required:
    "Bank transaction ID is required",
  bankreconciliation_either_invoicepayment_invices_reqired:
    "Either invoice or payment invoices are required",
  bankreconciliation_either_invoicepayment_invoices_reqired:
    "Either invoice or payment invoices are required",
  bankreconciliation_banktransaction_notfound: "Bank transaction not found",
  bankreconciliation_paymenttransaction_notfound:
    "Payment transaction not found",
  bankreconciliation_transactionTypeMismatch: "Transaction type mismatch",
  bankreconciliation_transactionCurrencyMismatch:
    "The payment transaction currency ({{0}}) and bank transaction currency ({{1}}) must match.",
  bankreconciliation_transactionAmountMismatch:
    "The payment transaction amount ({{0}}) and bank transaction amount ({{1}}) must match.",
  bankreconciliation_invoice_deleted: "Invoice is deleted",
  bankreconciliation_invoice_status_processedorreviewed:
    "Invoice status is processed or reviewed",
  bankreconciliation_invoice_transactionTypeMismatch:
    "Invoice transaction type mismatch",
  bankreconciliation_invoice_paymentStatusMissMatch:
    "Invoice payment status mismatch",
  bankreconciliation_invoice_approvalrequired: "Invoice approval is required",
  bankreconciliation_invoice_customercompanyidrequired:
    "Invoice customer company ID is required",
  bankreconciliation_invoice_customercompanyidshouldsame:
    "Invoice customer company ID should be the same",
  bankreconciliation_invoice_vendorcompanyidrequired:
    "Invoice vendor company ID is required",
  bankreconciliation_invoice_vendorcompanyidshouldsame:
    "Invoice vendor company ID should be the same",
  bankreconciliation_banktransaction_shouldbe_fullyreconciled: `Bank transaction should be fully reconciled`,
};
